import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3","key":"svg-0"}],["path",{"d":"M4 14l8 -3l8 3","key":"svg-1"}]]

const IconShieldChevron = createReactComponent('outline', 'shield-chevron', 'ShieldChevron', __iconNode);

export default IconShieldChevron;